import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'epn-ui/umd/dist/components/Button';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import useI18n from '@i18n';

const FilterButton: React.FC<{
    icon: IconProp;
    filtersDirty: boolean;
    onClick: () => void;
    isOpen: boolean;
}> = ({ icon, filtersDirty, onClick, isOpen }) => {
    const { t } = useI18n('Offers');
    return (
        <Button
            type="default"
            id="CouponsMobileFilterToggleButton"
            className="w-full"
            onClick={onClick}
        >
            <p className="flex items-center gap-[8px]">
                {isOpen ? t('Close filters') : t('Open filters')} <FontAwesomeIcon icon={icon} />
            </p>
            {filtersDirty && (
                <span className="absolute inline-block w-4 h-4 bg-red-500 border-4 border-white rounded-full right-2 top-1.5" />
            )}
        </Button>
    );
};

export default FilterButton;
